import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import InputMask from 'react-input-mask';
import Alert from 'react-s-alert';
import withForm from 'modules/common/hoc/withForm';
import NumberFormat from 'react-number-format';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

function LandSupersededAssessmentModal({
  createLandRecordofSupAssessment,
  updateLandRecordofSupAssessment,
  getLandRecordofSupAssessmentList,
  history,
  type,
  id,
  applicationId,
  updateList,
  findTdn,
}) {
  const [formData, setFormData] = useState({
    pin: '',
    arp_no: '',
    td_no: '',
    total_assessed_value: '',
    previous_owner: '',
    effectivity_of_assessment: '',
    ar_page_no: '',
    recording_person: '',
    date: '',
    previous_land_application_id: '',
  });
  const validateForm = useFormValidator(formData, {
    pin: 'required',
    arp_no: 'required|rptax_tdn',
    td_no: 'required|rptax_tdn',
    total_assessed_value: 'required',
    previous_owner: 'required',
    effectivity_of_assessment: 'required',
    ar_page_no: 'required',
    recording_person: 'required',
    date: 'required',
  });
  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      date: `${moment(_.get(formData, 'date')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      effectivity_of_assessment: `${moment(_.get(formData, 'effectivity_of_assessment')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
    };

    if (type === 'NEW') {
      createLandRecordofSupAssessment(applicationId, args, () => {
        setModal({ isOpen: false });
        getLandRecordofSupAssessmentList(applicationId);
        history.push(`/rpt/land/applications/${applicationId}`);
      });
    }

    if (type === 'EDIT') {
      updateLandRecordofSupAssessment(applicationId, id, args, () => {
        setModal({ isOpen: false });
        getLandRecordofSupAssessmentList(applicationId);
        history.push(`/rpt/land/applications/${applicationId}`);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        effectivity_of_assessment: `${moment(updateList.effectivity_assessment).format(
          'MM-DD-YYYY HH:mm'
        )}:00`,
        date: `${moment(updateList.date).format(
          'MM-DD-YYYY HH:mm'
        )}:00`,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'NEW') {
      setFormData({
        pin: '',
        arp_no: '',
        td_no: '',
        total_assessed_value: '',
        previous_owner: '',
        effectivity_of_assessment: `${moment(updateList.effectivity_assessment).format(
          'MM-DD-YYYY HH:mm'
        )}:00`,
        ar_page_no: '',
        recording_person: '',
        date: '',
        previous_land_application_id: '',
      })
    }
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const searchTdn = (e) => {
    e.preventDefault();
    findTdn({ tdn: formData.arp_no }, (landData) => {
      if (!_.isEmpty(landData)) {
        Alert.success("Application Found.")
        setFormData({
          ...formData,
          land_application_id: _.get(landData, 'data.attributes.id'),
          arp_no: _.get(landData, 'data.attributes.arp_no'),
          pin: _.get(landData, 'data.attributes.pin'),
          total_assessed_value: _.get(landData, 'data.attributes.total_assessed_value'),
          previous_owner: _.get(landData, 'included.[1].attributes.name'),
          address: _.get(landData, 'data.attributes.property_address'),
          assessed: _.get(landData, 'data.attributes.appraised_assessed_by'),
          barangay_id: _.get(landData, 'data.attributes.property_barangay_id'),
          td_no: _.get(landData, 'data.attributes.tdn'),
          previous_land_application_id: _.get(landData, 'data.attributes.previous_land_application_id'),
        });
      } else {
        Alert.error("No Application Found.")
      }
    });
  };

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">Pin {validateForm.renderMessage('pin')}</label>
            <input
              className="form-control"
              type="text"
              name="pin"
              onChange={onChange}
              value={_.get(formData, 'pin') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">ARP No. {validateForm.renderMessage('arp_no')}</label>
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="arp_no"
              onChange={onChange}
              value={_.get(formData, 'arp_no')}
            />
          </div>
          <div className="search-div-transaction d-flex align-items-start ml-2 pt-4">
            <button
              disabled={_.get(formData, 'arp_no') === '__-_____-_____' || _.get(formData, 'arp_no') === ''}
              type="button"
              onClick={searchTdn}
              className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
            >
              <span className="icon">
                <i className="fa fa-lg fa-search" />
              </span>
            </button>
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">TD No. {validateForm.renderMessage('td_no')}</label>
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="td_no"
              onChange={onChange}
              value={_.get(formData, 'td_no')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">Total Assessed Value {validateForm.renderMessage('total_assessed_value')}</label>
            <NumberFormat
              name="total_assessed_value"
              id='total_assessed_value'
              style={{ outline: "none", borderRadius: "7px" }}
              placeholder="_"
              allowLeadingZeros
              className="form-control text-uppercase my-2"
              onValueChange={(values) => {
                const { floatValue } = values;

                setFormData(() => ({
                  ...formData,
                  total_assessed_value: floatValue,
                }));
              }}
              displayType="input"
              thousandSeparator
              isNumericString
              prefix=""
              value={_.get(formData, "total_assessed_value")?.toString() || '0'}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Previous Owner {validateForm.renderMessage('previous_owner')}
            </label>
            <input
              className="form-control"
              type="text"
              name="previous_owner"
              onChange={onChange}
              value={_.get(formData, 'previous_owner')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Effectivity of Assessment: {validateForm.renderMessage('effectivity_of_assessment')}
            </label>
            <DateInputPicker
              withTime
              className="full-input"
              onChange={handleOnChangeDate('effectivity_of_assessment')}
              value={_.get(formData, 'effectivity_of_assessment') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              ARP Page No. {validateForm.renderMessage('ar_page_no')}
            </label>
            <input
              className="form-control"
              type="text"
              name="ar_page_no"
              onChange={onChange}
              value={_.get(formData, 'ar_page_no')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Recording Person {validateForm.renderMessage('recording_person')}
            </label>
            <input
              className="form-control"
              type="text"
              name="recording_person"
              onChange={onChange}
              value={_.get(formData, 'recording_person')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Date {validateForm.renderMessage('date')}
            </label>
            <DateInputPicker
              withTime
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={_.get(formData, 'date') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

LandSupersededAssessmentModal.defaultProps = {
  type: '',
  applicationId: '',
  updateList: {},
  id: '',
};

LandSupersededAssessmentModal.propTypes = {
  getLandRecordofSupAssessmentList: PropTypes.instanceOf(Function).isRequired,
  createLandRecordofSupAssessment: PropTypes.instanceOf(Function).isRequired,
  updateLandRecordofSupAssessment: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
  applicationId: PropTypes.string,
  id: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  findTdn: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(LandSupersededAssessmentModal);
